export default function formatOrdinal(integer) {
    var output = integer;

    if (integer % 10 == 1) {
        output += "st";
    } else if (integer % 10 == 2) {
        output += "nd";
    } else if (integer % 10 == 3) {
        output += "rd";
    } else {
        output += "th";
    }

    return (output);
}